import { getLocale } from "../runtime";

const sv_secountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Sweden`
};

const secountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_secountryenglish(inputs)
	return "seCountryEnglish";
};

export { secountryenglish as "seCountryEnglish" };